export default __webpack_public_path__ + "static/en1-aa7ba51a31948ca60b3da7738adceb93.webp";